import { render, staticRenderFns } from "./ChoiceGroup.vue?vue&type=template&id=720bb347&scoped=true&"
import script from "./ChoiceGroup.vue?vue&type=script&lang=js&"
export * from "./ChoiceGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceGroup.scss?vue&type=style&index=0&id=720bb347&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720bb347",
  null
  
)

export default component.exports